import { createFileRoute, Outlet, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";
import { modCanWorkspace, type ModeratorPermissions } from "@/lib/moderator-permissions";

export const Route = createFileRoute("/_app/_team")({
  component: TeamLayout,
});

function TeamLayout() {
  const { role, profile, loading } = useAuth();
  if (loading) return null;
  if (role === "admin") return <Outlet />;
  if (role !== "moderator") return <Navigate to="/dashboard" />;
  const perms = (profile?.moderator_permissions ?? {}) as ModeratorPermissions;
  const hasAny =
    modCanWorkspace(perms, "view_overview") ||
    modCanWorkspace(perms, "view_activity_feed") ||
    modCanWorkspace(perms, "search_users") ||
    Object.values(perms.departments ?? {}).some((d) =>
      Object.values(d ?? {}).some(Boolean),
    );
  if (!hasAny) return <Navigate to="/dashboard" />;
  return <Outlet />;
}
